module.exports = __webpack_public_path__ + "static/img/智能报账6.ca82335d.png";